export default {
  title: 'Dane bankowe',
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    success: 'Twoje informacje zostały pomyślnie zapisane.',
  },
};
